var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.5 43.5",
    style: {
      enableBackground: "new 0 0 43.5 43.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8,43.5h-8.3v-3.8c0-2.6-2-4.6-4.7-4.6c-2.6,0-4.6,2-4.6,4.6v3.8H4.8c-2.6,0-4.8-2.1-4.8-4.8v-8.3h3.8 c2.6,0,4.7-2.1,4.7-4.7c0-2.6-2.1-4.6-4.7-4.6H0v-8.4C0,10.2,2.2,8,4.8,8H12V5.8C12,2.6,14.6,0,17.8,0s5.8,2.5,5.8,5.8V8h7.3 c2.6,0,4.8,2.1,4.8,4.8V20h2.3c3.2,0,5.8,2.6,5.8,5.8c0,3.2-2.5,5.8-5.8,5.8h-2.3v7.3C35.5,41.4,33.4,43.5,30.8,43.5z M24,42h6.8 c1.8,0,3.3-1.5,3.3-3.3V30h3.8c2.4,0,4.3-1.9,4.3-4.3c0-2.3-1.9-4.3-4.3-4.3H34v-8.8c0-1.8-1.5-3.3-3.3-3.3H22V5.8 c0-2.4-1.9-4.3-4.3-4.3s-4.3,1.9-4.3,4.3v3.8H4.8C3,9.5,1.5,11,1.5,12.8v6.9h2.3c3.4,0,6.2,2.8,6.2,6.1c0,3.4-2.8,6.2-6.2,6.2H1.5 v6.8C1.5,40.6,3,42,4.8,42h6.9v-2.3c0-3.4,2.8-6.1,6.1-6.1s6.2,2.8,6.2,6.1V42z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.b3ef6f4d.svg";
export { ForwardRef as ReactComponent };